<template>
  <div v-if="showNewsletter">
    <h3 class="newsletter-header" v-if="!sent">{{ t('newsletter.notFound') }}</h3>
    <div
      class="newsletter-consent" v-if="!sent"
    >
    <label>
      <input
        type="checkbox"
        id="toggle-newsletter-confirmation"
        @change="toggleNewsletter()"
        ref="toggleReadNotifications"
        :checked="newsletterConfirm"
      >
      {{ t('newsletter.wantMore') }}
    </label >
    </div>
    <div class="newsletter-signup">
        <button
          class="button button--primary"
          @click="requestNewsletter"
          v-if="!sent"
          :disabled="!newsletterConfirm"
        >
          {{ t('newsletter.subscribe') }}
        </button>
    </div>
    <div v-if="sent">{{ t('newsletter.thankYou') }}</div>
  </div>
</template>

<script setup lang="ts">
  import { useAuthStore } from '@/stores/useAuthStore'
  import { useHttpClient } from '@/composables/useHttpClient'
  import { useStrings } from '@/composables/useStrings.ts'
  import { computed, ref } from 'vue'

  const { t } = useStrings()
  const authStore = useAuthStore()
  const { proxyApi } = useHttpClient()

  const sent = ref(false)
  const newsletterConfirm = ref(false)

  const showNewsletter = computed(() => {
    const userName = authStore.userName
    return (userName?.length ?? 0) > 0 && userName?.includes('@')
  })

  const toggleNewsletter = () => {
    newsletterConfirm.value = !newsletterConfirm.value
  }

  const requestNewsletter = async () => {
    //BPE
    try {
      await proxyApi.post(`/newsletter?email=${encodeURIComponent(authStore.userName as string)}`, {})
      sent.value = true
    } catch (err) {
      console.error(err)
    }
  }
</script>

<style lang="scss" scoped>
  .newsletter-header {
    text-align: center;
  }

  .newsletter-consent {
    text-align: center;
  }

  .newsletter-signup {
    text-align: center;
    margin: 4px;
  }

  #toggle-newsletter-confirmation {
    margin-right: 30px;
  }
</style>
